import * as v from "valibot";

export const authUserDto = {
  id: v.string(),
  email: v.string(),
  name: v.string(),
  isNewUser: v.boolean(),
};
export type AuthUserDto = v.InferOutput<v.ObjectSchema<typeof authUserDto, undefined>>;

/** Without `refreshToken` the server reads it from the HttpOnly refresh cookie (a browser); a device sends it in the body. */
export const refreshTokenRequest = {
  refreshToken: v.optional(v.pipe(v.string(), v.maxLength(1024))),
};
export type RefreshTokenRequest = v.InferOutput<v.ObjectSchema<typeof refreshTokenRequest, undefined>>;

/** `refreshToken` is empty when it went into the HttpOnly refresh cookie instead (see REFRESH_TOKEN_TRANSPORT_HEADER). */
export const refreshTokenResponse = {
  accessToken: v.string(),
  accessTokenExpiresAt: v.number(),
  refreshToken: v.string(),
  refreshTokenExpiresAt: v.number(),
};
export type RefreshTokenResponse = v.InferOutput<v.ObjectSchema<typeof refreshTokenResponse, undefined>>;

/** The token to revoke; without it the server revokes the one in the refresh cookie. */
export const signOutRequest = {
  refreshToken: v.optional(v.pipe(v.string(), v.maxLength(1024))),
};
export type SignOutRequest = v.InferOutput<v.ObjectSchema<typeof signOutRequest, undefined>>;
